// Per-user module access helpers. `module_access` null/absent = full role access.
const HR_VIEW_ONLY = ['/attendance', '/salary-revisions', '/eosb', '/invoices', '/salary-advances'];
const HR_NONE = ['/settings', '/branding', '/email-log'];
const PAYROLL_EDIT = ['/attendance', '/salary-revisions', '/eosb', '/salary-advances', '/part-timers', '/clock-in-out', '/invoices'];
const PAYROLL_VIEW = ['/dashboard', '/employees', '/leaves', '/leave-calendar', '/public-holidays', '/hr-report', '/salary-certificate'];
const VIEWER_NONE = ['/settings', '/branding', '/email-log', '/bulk-email'];
const REPORT_VIEW = ['/dashboard', '/hr-report', '/leave-forecast', '/leave-calendar'];

export const VIEW_ONLY_ROLES = ['viewer', 'report_viewer'];

export const presetForRole = (role, hrefs) => {
  const out = {};
  hrefs.forEach((h) => {
    let lvl = null;
    if (role === 'admin' || role === 'super_admin') lvl = 'edit';
    else if (role === 'hr_manager') lvl = HR_NONE.includes(h) ? null : HR_VIEW_ONLY.includes(h) ? 'view' : 'edit';
    else if (role === 'payroll_manager') lvl = PAYROLL_EDIT.includes(h) ? 'edit' : PAYROLL_VIEW.includes(h) ? 'view' : null;
    else if (role === 'viewer') lvl = VIEWER_NONE.includes(h) ? null : 'view';
    else if (role === 'report_viewer') lvl = REPORT_VIEW.includes(h) ? 'view' : null;
    if (lvl) out[h] = lvl;
  });
  return out;
};

export const getModuleAccess = (user, href) => {
  if (!user || user.role === 'super_admin' || !user.module_access) return 'edit';
  return user.module_access[href] || null;
};
